import { useMemo } from "react";
import { usePage } from "@inertiajs/react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

type ErrorBag = Record<string, string | string[]>;

interface PageProps {
  errors?: ErrorBag;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

const normalizeErrors = (errors?: ErrorBag) => {
  if (!errors) return [];
  const messages: string[] = [];

  Object.values(errors).forEach((value) => {
    if (Array.isArray(value)) {
      value.forEach((message) => {
        if (message) messages.push(message);
      });
      return;
    }
    if (value) messages.push(value);
  });

  return Array.from(new Set(messages));
};

export default function GlobalErrors() {
  const { errors } = usePage<PageProps>().props;
  const messages = useMemo(() => normalizeErrors(errors), [errors]);

  if (messages.length === 0) return null;

  return (
    <Alert variant="destructive">
      <AlertTitle>يرجى تصحيح الأخطاء أدناه</AlertTitle>
      <AlertDescription>
        <ul className="list-disc space-y-1 pr-4">
          {messages.map((message, index) => (
            <li key={`${message}-${index}`}>{message}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
